import { ReactElement } from 'react';
import { AppointmentSummary } from '@provider-directory/components/appointment-summary/appointment-summary.component';
import { SplitScreen } from '@provider-directory/components/split-screen/split-screen.component';
import { useAppointment } from '@provider-directory/contexts/AppointmentContext';
import { SelectAppointmentSlotForm } from '../select-appointment-slot-form/select-appointment-slot-form.component';

export default function SelectAppointmentSlot({
  onPrev,
  onNext,
}: {
  onPrev: () => void;
  onNext: () => void;
}): ReactElement {
  const {
    appointment: { reasonForVisit },
  } = useAppointment();

  const liveSlotsRfv = reasonForVisit || '';

  return (
    <SplitScreen
      additionalClassnames={{
        left: {
          screen: 'bg-white',
        },
        right: {
          screen: 'bg-white desktop:bg-primary-50',
        },
      }}
    >
      <SelectAppointmentSlotForm
        onNext={onNext}
        onPrev={onPrev}
        reasonForVisit={liveSlotsRfv}
      />
      <AppointmentSummary />
    </SplitScreen>
  );
}
